<!--
 * @Date: 2022-08-03 17:32:10
 * @LastEditTime: 2022-08-15 14:28:38
 * @FilePath: /vue-medweb/packages/vue-m-comprehensive/src/components/Barrage/index.vue
 * @Description: 弹幕区域
-->
<template>
  <cube-slide
    ref="slide"
    :auto-play="true"
    :interval="3000"
    :loop="true"
    :show-dots="false"
    :data="thanksList"
    :options="{ disableTouch: true }"
    class="barrage-content-wrap"
  >
    <cube-slide-item v-for="(item, index) in thanksList" :key="index">
      <div class="item">
        <img class="icon" :src="item.image" />
        <div class="content">{{ item.content }}</div>
      </div>
    </cube-slide-item>
  </cube-slide>
</template>

<script>
export default {
  name: 'Barrage',
  props: {
    thanksList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.barrage-content-wrap {
  position: relative;
  top: rem(56);
  width: 100%;
  .item {
    display: flex;
    justify-content: space-between;
    margin: 0 rem(15);
    padding: rem(13) rem(15);
    white-space: normal;
    text-align: left;
    word-wrap: break-word;
    word-break: break-all;
    background: #ddfcfe;
    border-radius: rem(8);
  }
  .icon {
    flex-basis: rem(29);
    flex-shrink: 0;
    height: rem(29);
    margin-right: rem(10);
    background: #fffffe;
    border-radius: 50%;
  }
  .content {
    font-size: rem(11);
    line-height: rem(15);
    @include multiple-ellipsis(4);
  }
}
</style>
